module.exports = __webpack_public_path__ + "img/row_drag.2400329a.svg";